import Vue from 'vue'
import VueI18n from 'vue-i18n';
import country_langs from '../../../../../public/js/lang/country_langs.json'
import country_default_langs from '../../../../../public/js/lang/country_default_langs.json'
import es from '../../../../../public/js/lang/es.json'


class CustomVueI18n extends VueI18n {
    constructor(props) {
        super(props);
    }
    _te(key, locale, messages, ...args) {
        const chain = this._getLocaleChain(locale, this.fallbackLocale);
        return chain.some((lang) => super._te(key, lang, messages, ...args));
    }
    get locale () { return this._vm.locale }
    set locale (locale) {
        this.setLocale(locale);
    }
    async setLocale(locale){
        if (locale === undefined) {
            return;
        }
        await this.loadLocale(locale);
        this._vm.$set(this._vm, 'locale', locale);
    }
    async loadLocale(locale) {
        const langs = this.fallbackLocale[locale];
        for (let langIdx in langs) {
            let lang = langs[langIdx];
            console.log("I18N checking lang:"+lang);
            if (Object.keys(this.getLocaleMessage(lang)).length == 0) {
                console.log("I18N loading lang:"+lang);
                try {
                    const res = await fetch(`/js/lang/${lang}.json`);
                    if (!res.ok) throw new Error("Language file not found: " + lang, {code: "LANG_NOT_FOUND"});
                    const data = await res.json();
                    this.setLocaleMessage(lang, data);
                }
                catch(e) {
                    if (e instanceof Error && e.code === "LANG_NOT_FOUND") {
                        console.log("I18N NOT FOUND lang: " + lang);
                    } else {
                        console.log("I18N FAIL loading lang: " + lang);
                        console.log(e)
                    }
                }
            }
        }
    }
    transFromMap(map, key, locale) {
        let mapKey = `maps.${map}.${key}`;
        let trans = this.t(mapKey, locale);
        if (trans == mapKey) {
            let lastPart = key.split('##').at(-1);
            lastPart = lastPart.replace('_',' ');
            trans = lastPart.charAt(0).toUpperCase() + lastPart.slice(1);
        }
        return trans;
    }

}

Vue.use(CustomVueI18n)
Vue.prototype.$tmap = function(map, key, locale) {
    let i18n = this.$i18n;
    return i18n.transFromMap.apply(i18n, [map, key, locale]);
}
// building decision fallback translation
const getFallbackLocale = () => {
    const langFallback = 'es';
    let fallbackLocale = {};
    let aira_langs = window.AIRA_LANGS ? window.AIRA_LANGS : "es";
    aira_langs = aira_langs.split(',');
    const country_codes = country_langs;
    const default_langs = country_default_langs;
    aira_langs.forEach(lang => {
        if (lang !== langFallback) {
            fallbackLocale[`${lang}`] = [lang, langFallback];
        }
        Object.entries(country_codes).forEach(([country, country_code]) => {
            let fallbacks = [`${lang}_${country_code}`, lang];
            const defaultLang = default_langs[country];
            if (defaultLang && !fallbacks.includes(defaultLang)) {
                fallbacks.push(defaultLang);
            }
            if (lang !== langFallback) {
                fallbacks.push(`${langFallback}_${country_code}`);
            }
            fallbackLocale[`${lang}_${country_code}`] = [...new Set(fallbacks)];
        });
    });
    fallbackLocale['default'] = [ window.LANG_LOCALE ? window.LANG_LOCALE : langFallback, langFallback ];
    return fallbackLocale;
}

const i18n = new CustomVueI18n({
    locale: window.LANG_LOCALE ? window.LANG_LOCALE : "es",
    fallbackLocale: getFallbackLocale(),
    messages: {es},
    silentTranslationWarn: true
});
i18n.locale = window.LANG_LOCALE ? window.LANG_LOCALE : "es";

export {
    i18n
}